<template>
  <span class="DataTable-TableHeader-label"><slot /></span>
</template>

<script>
export default {
  name: "TableHeaderLabel",
};
</script>
